import { ExerciseWithStandaloneSimulation } from '../constants';
import {
  ActiveClassroom,
  ActiveSimulation,
  ExerciseType,
  InstructorClassroomSession,
  LoadingSimulation,
  SimulationRole,
  SimulationState,
  SimulatorType,
} from '../types';
import { Pages } from '../types/pages';

export const isLoading = (activeSimulation?: ActiveSimulation): activeSimulation is LoadingSimulation =>
  (!!activeSimulation && !('state' in activeSimulation)) || activeSimulation?.state === SimulationState.Unknown;

export const isRunning = (activeSimulation?: ActiveSimulation) =>
  !!(
    activeSimulation &&
    (activeSimulation.simulator.type === SimulatorType.Site
      ? simulationProgressLoaded(activeSimulation.progress)
      : activeSimulation.exercise.type === ExerciseType.Classroom
      ? simulationProgressLoaded(activeSimulation.progress)
      : activeSimulation.url)
  );

export const isInstructorClassroom = (
  activeClassroom?: ActiveClassroom,
): activeClassroom is InstructorClassroomSession =>
  !!activeClassroom && activeClassroom.role === SimulationRole.Instructor;

export const getSimulationPath = (
  isStudent?: boolean,
  exerciseId?: string,
  simulationId?: string,
  simulationRole?: SimulationRole,
  type?: ExerciseType,
) =>
  `${
    isStudent || simulationRole === SimulationRole.Student || type === ExerciseType.SelfStudy
      ? Pages.Learn
      : Pages.Teach // we need this check because the user can be Instructor assigned to the simulation as a Student
  }/exercises/${exerciseId}/simulations/${simulationId}`;

export const isScheduleExercise = (exerciseId?: string) => exerciseId !== ExerciseWithStandaloneSimulation;

export const simulationProgressLoaded = (progress: number) => progress === 100;
